import { useCallback } from 'react';
import mixpanelService from 'services/mixpanelService';
import useGetMixpanelProps from './useGetMixpanelProps';
import { SignupInitiatedProps } from 'models/MixpanelEvents';

export default function useMixpanelSignupInitiated() {
  const getMixpanelProps = useGetMixpanelProps();

  return useCallback(
    (signupInitiatedProps: Omit<SignupInitiatedProps, 'pageUrl'>) => {
      mixpanelService.signupInitiated(
        getMixpanelProps(signupInitiatedProps) as SignupInitiatedProps,
      );
    },
    [getMixpanelProps],
  );
}
